/**
 * Pure cache-URL selector used by AuthGate to feed ZeroProvider.
 *
 * Extracted in v0.1.44 specifically to make the precedence rule
 * testable and impossible to silently revert. Pre-v0.1.44, the logic
 * preferred `explicitCacheUrl` (set at build time via
 * `VITE_ZERO_CACHE_URL` from Doppler) over the regional resolver's
 * output. Doppler had it pinned to `https://sync.ano.dev/`, which
 * CF-routes to api-us — so every prod desktop built between v0.1.39
 * and v0.1.43 silently forced ZeroProvider onto api-us no matter
 * what region the active workspace lived in. The region resolver was
 * correct; its answer just never reached ZeroProvider.
 *
 * Rule for v0.1.44+:
 *
 * - **Built desktop app** → always `regionalSyncUrl`. The build-time
 *   env override is ignored because it has no way to know the user's
 *   active workspace's region.
 * - **Dev / web** → `explicitCacheUrl` if set, else the dev fallback
 *   (`http://localhost:4848`). Dev needs the override for E2E tests
 *   and for pointing at a deployed sync stack from a local renderer.
 */
export function selectCacheURL(args: {
  isBuiltApp: boolean;
  regionalSyncUrl: string;
  explicitCacheUrl: string | undefined;
  devFallback?: string;
}): string {
  if (args.isBuiltApp) return args.regionalSyncUrl;
  return args.explicitCacheUrl ?? args.devFallback ?? "http://localhost:4848";
}
